'use client'

import { jsx, jsxs } from 'react/jsx-runtime';
import { createContext, useContext, useEffect } from 'react';

const ReadinessContext = createContext({});
const ReadinessProvider = ({ children, experimental = {} }) => {
  return /* @__PURE__ */ jsx(ReadinessContext.Provider, { value: experimental, children });
};
const Experimental = ({
  name,
  children,
  dependencies = {}
}) => {
  const readiness = useContext(ReadinessContext);
  const combinedReadiness = { ...readiness, ...dependencies };
  const isOptIn = !!combinedReadiness[name];
  useEffect(() => {
    if (isOptIn) {
      console.warn(
        `Warning: Component ${name} is marked as experimental, it could change at any time.`
      );
    }
  }, [isOptIn]);
  return isOptIn ? /* @__PURE__ */ jsx(ReadinessProvider, { experimental: combinedReadiness, children }) : /* @__PURE__ */ jsxs("div", { children: [
    "Component ",
    name,
    " is marked as experimental. To use, you will need to opt-in via `experimental` props in `ConfigProvider`."
  ] });
};

export { Experimental, ReadinessProvider };
//# sourceMappingURL=lifecycles.mjs.map
